import { render, staticRenderFns } from "./sel-box-with-store.vue?vue&type=template&id=c8072642&scoped=true&"
import script from "./sel-box-with-store.vue?vue&type=script&lang=js&"
export * from "./sel-box-with-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8072642",
  null
  
)

export default component.exports